// extracted by mini-css-extract-plugin
export default {"ActionsWrapper":"_ActionsWrapper--TPwiz","Icon":"_Icon--TQ5Uw","Body":"_Body--jhJ_A"};